import { StyleSheet } from 'aphrodite';
export var styles = StyleSheet.create({
  dragArea: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    zIndex: 3,
    display: 'flex',
    flexDirection: 'column',
    background: 'rgba(255, 255, 255, 0.8)',
    justifyContent: 'center',
    alignItems: 'center',
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 0.4s linear, visibility 0s linear 0.4s'
  },
  showDragArea: {
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.4s linear, visibility 0s linear 0s'
  },
  scopedOverlay: {
    position: 'absolute'
  }
});